import { Link, useParams } from "react-router-dom";

export function BoardCellRenderer(props) {
  const params = useParams();
  try {
    return (
      <Link
        to={`//${process.env.REACT_APP_LOCAL_URL}tattle/${params.attribute_set_key}/${props.value}`}
      >
        {props.value}
      </Link>
    );
  } catch (error) {
    console.log(error.message);
  }
}
